export const enum BillingType {
	CreditCard = 1,
	Boleto = 2,
	Pix = 3,
	PixAutomatic = 6
}
